export default __webpack_public_path__ + "static/media/Web2.0-RegisterPage-First.2c75048e.png";